import { useEffect } from 'react';
import { de } from '@/i18n/de';
import { useAppStore } from '@/lib/store';

function Toast({ id, text, onDone }: { id: number; text: string; onDone: () => void }) {
  useEffect(() => {
    const timer = setTimeout(onDone, 4000);
    return () => clearTimeout(timer);
  }, [id, onDone]);

  return (
    <div
      role="alert"
      className="animate-phase-in rounded-xl border border-surface-border bg-surface-2 px-4 py-3 text-sm text-fg shadow-lg"
    >
      {text}
    </div>
  );
}

/**
 * Hinweise über dem unteren Bildschirmrand.
 *
 * Bewusst ohne `AnimatePresence`, wie das `Sheet` und aus demselben Grund: ein
 * Toast, dessen Verschwinden an einer JS-Animation hängt, bleibt bei nicht
 * abgeschlossener Animation unsichtbar liegen — und weil die Kacheln
 * `pointer-events-auto` tragen, sammelt sich über dem Fußbereich Tap für Tap
 * eine unsichtbare Sperrschicht an. Das Erscheinen ist Schmuck, das
 * Verschwinden nicht.
 */
export function Toasts() {
  const toasts = useAppStore((s) => s.toasts);
  const dismiss = useAppStore((s) => s.dismissToast);

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+5rem)] z-50 flex flex-col items-center gap-2 px-4"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto w-full max-w-sm">
          <Toast
            id={toast.id}
            text={'code' in toast ? de.errors[toast.code] : toast.text}
            onDone={() => dismiss(toast.id)}
          />
        </div>
      ))}
    </div>
  );
}
